import { types } from "../actions";

const initialState = {
  ruleName: "",
  siteSelected: {},
  appSelected: {},
  floorSelected: {},
  cvAppRois: [],
  roiSelected: [],
  roiDatas: [],
  areaSelected: {},
  subAreaSelected: {},
  isValidName: true,
  captureVideoEvidence: true,
  triggerActions: {
    timeFrame: "RB1",
    customData: {
      timeParam: "",
      selectedDays: {
        Su: false,
        Mo: false,
        Tu: false,
        We: false,
        Th: false,
        Fr: false,
        Sa: false,
      },
      startTime: "12:00 AM",
      endTime: "12:30 AM",
      overNightText: false,
      timeZone: "ET",
    },
    triggerData: {
      coolPeriodValue: 10,
      addCoolDownPeriod: true,
    },
    severity: "",
    groups: [],
    sms: true,
    email: true,
  },
  selAppType: "",
  selectedLocation: "",
  roiImages: {},
  notificationGroups: [],
  floorData: [],
  floorImageData: [],
  selectedTab: 0,
  colorsSelected: [],
  is_color_exclusion_set: false,
  enableColorAppearance: false,
  changedParkingOccupancy: undefined,
  filteredSiteList: [],
};

const ruleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_RULE_VALUES: {
      const updates = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      return updates.reduce((newState, { propName, value }) => {
        if (propName === "roiImages") {
          return {
            ...newState,
            roiImages: {
              ...newState.roiImages,
              ...value,
            },
          };
        } else if (propName === "customData") {
          return {
            ...newState,
            triggerActions: {
              ...newState.triggerActions,
              customData: {
                ...newState.triggerActions.customData,
                ...value,
              },
            },
          };
        } else if (propName === "triggerActions") {
          return {
            ...newState,
            triggerActions: {
              ...newState.triggerActions,
              ...value,
            },
          };
        } else if (propName === "triggerData") {
          return {
            ...newState,
            triggerActions: {
              ...newState.triggerActions,
              triggerData: {
                ...newState.triggerActions.triggerData,
                ...value,
              },
            },
          };
        } else if (propName === "colorsSelected") {
          return {
            ...newState,
            colorsSelected: [...[].concat(value)], // Clear previous value and update
          };
        } else if (propName === "roiColorData") {
          return {
            ...newState,
            roiColorData: [...[].concat(value)], // Clear previous value and update
          };
        } else if (propName === "is_color_exclusion_set"){
          return {
            ...newState,
            is_color_exclusion_set: value,
          }
        } else if (propName === "enableColorAppearance"){
          return {
            ...newState,
            enableColorAppearance: value,
          }
        }
        else {
          return {
            ...newState,
            [propName]: Array.isArray(newState[propName])
              ? [...newState[propName], ...[].concat(value)]
              : typeof newState[propName] === "object" &&
                newState[propName] !== null
              ? { ...newState[propName], ...value }
              : value,
          };
        }
      }, state);
    }
    case types.RESET_RULE_VALUES: {
      return action.payload.reduce((newState, propName) => {
        if (propName === "roiSelected") {
          return {
            ...newState,
            roiSelected: [],
          };
        }
        return {
          ...newState,
          [propName]: initialState[propName],
        };
      }, state);
    }
    case types.RESET_ALL_RULES:
      return initialState;
    default:
      return state;
  }
};

export default ruleReducer;
